import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import axios from 'axios';
import dayjs from 'dayjs';
import UA from 'drip/ua';
import KNB from '@dp/knb';
import Store from 'drip/store';
import { ajaxNewMwebPreUrl } from '@/config';
import Url from 'drip/utils/url';
import PopSuccess from '@/components/pre-ticket/pop-success.vue';
import CalendarSuccess from '@/components/pre-modal/calendarSuccess.vue';
import CalendarAndriod from '@/components/pre-modal/calendarAndriod.vue';
import { notifyCalendar } from '@/utils/notifyCalendar';
import openApp, { isProd } from '@/utils/openApp';
import Timer from './FansTimer.vue';
export default {
  components: {
    PopSuccess: PopSuccess,
    CalendarAndriod: CalendarAndriod,
    CalendarSuccess: CalendarSuccess,
    Timer: Timer
  },
  props: {
    title: String,
    // 正式开售时间
    onSaleTime: Number,
    // 提前可买时间
    earlySaleTime: {
      type: Number,
      default: 0
    },
    now: Number,
    countdownTime: Number,
    priorityActivityCardVO: Object,
    performanceId: Number,
    isNeedOnSaleRemind: Number,
    isShowCountDownComponent: Boolean
  },
  computed: {
    isLottery: function isLottery() {
      return this.priorityActivityCardVO.configWay === this.configWayEnums.LOTTERY || this.priorityActivityCardVO.configWay === this.configWayEnums.SIGN;
    },
    normalTimeStr: function normalTimeStr() {
      if (!this.onSaleTime) return;
      var str = dayjs(this.onSaleTime).month() + 1 + '月' + dayjs(this.onSaleTime).date() + '日 ' + dayjs(this.onSaleTime).format('HH:mm');
      return str;
    },
    earlyTimeStr: function earlyTimeStr() {
      var str = dayjs(this.earlySaleTime).month() + 1 + '月' + dayjs(this.earlySaleTime).date() + '日 ' + dayjs(this.earlySaleTime).format('HH:mm');
      return str;
    },
    showEarlyTime: function showEarlyTime() {
      // 实测开售按钮翻转大概有100ms的延迟，微调保持同步
      return this.earlySaleTime > this.now + 100;
    },
    showNormalTime: function showNormalTime() {
      // 同上
      return this.isShowCountDownComponent && this.onSaleTime > this.now + 100 && this.now > this.countdownTime;
    },
    earlyTimeLimit: function earlyTimeLimit() {
      // 抽奖优先购不设时间限制
      if (this.isLottery) return true;
      var timeDifference = this.earlySaleTime - this.now;
      var seventyTwoHoursInMs = 72 * 60 * 60 * 1000;
      return timeDifference < seventyTwoHoursInMs || timeDifference === seventyTwoHoursInMs;
    }
  },
  data: function data() {
    return {
      calendarAndriodVis: false,
      calendarSuccessVis: false,
      showPopSucess: false,
      bindMobile: '',
      start: null,
      configWayEnums: {
        // 裂变
        FISSION: 3,
        // 抽奖
        LOTTERY: 4,
        // 报名
        SIGN: 5,
        // 导入
        IMPORT: 6
      }
    };
  },
  created: function created() {
    var _this = this;
    if (UA.isNative && UA.osName === 'android') {
      KNB.subscribe({
        action: 'appear',
        handle: function () {
          var _handle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
            var calanderBack;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _this.subscribeId = res.subId;
                  _context.next = 3;
                  return Store.get('setCalendar');
                case 3:
                  calanderBack = !!_context.sent;
                  if (!calanderBack) {
                    _context.next = 8;
                    break;
                  }
                  _context.next = 7;
                  return Store.remove('setCalendar');
                case 7:
                  _this.showPopSucess = true;
                case 8:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function handle(_x) {
            return _handle.apply(this, arguments);
          }
          return handle;
        }()
      });
    }
  },
  destroyed: function destroyed() {
    if (this.subscribeId) {
      KNB.unsubscribe({
        action: 'appear',
        subId: this.subscribeId,
        success: function success() {},
        fail: function fail() {}
      });
    }
  },
  methods: {
    getRecordParams: function getRecordParams(bid) {
      var params = {
        viewBid: bid,
        cid: 'c_c21utqjf',
        custom: {
          custom: {
            performance_id: this.performanceId,
            activityId: this.priorityActivityCardVO.activityId
          }
        }
      };
      return JSON.stringify(params);
    },
    goSign: function goSign() {
      if (Number(this.priorityActivityCardVO.configWay) === this.configWayEnums.IMPORT) return;
      window.lxTagReport('b_movie_nnjw5e28_mc', 'b_movie_nnjw5e28_mv', {
        performance_id: this.performanceId,
        activityId: this.priorityActivityCardVO.activityId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_nnjw5e28_mv',
        cid: 'b_movie_nnjw5e28_mc',
        custom: {
          custom: {
            performance_id: this.performanceId,
            activityId: this.priorityActivityCardVO.activityId
          }
        }
      });
      if (this.priorityActivityCardVO.activityType === 2) {
        // 渠道合作优先购
        Drip.redirect(Url.getUrl('/myshowfe/trade/priorityPurchase', {
          projectId: this.performanceId
        }));
      } else {
        Store.set('detailPageShouldReload', true);
        if (this.priorityActivityCardVO.configWay === this.configWayEnums.FISSION) {
          var _Drip$constant, _this$priorityActivit;
          var sellChannel = (_Drip$constant = Drip.constant) === null || _Drip$constant === void 0 ? void 0 : _Drip$constant.appType;
          var url = "https://i.test.maoyan.com/swan/group/index?group_activity_id=".concat((_this$priorityActivit = this.priorityActivityCardVO) === null || _this$priorityActivit === void 0 ? void 0 : _this$priorityActivit.businessId, "&sellChannel=").concat(sellChannel);
          Drip.redirect(url);
        }
        if (this.isLottery) {
          Drip.redirect(this.priorityActivityCardVO.businessUrl);
        }
      }
    },
    handleRemind: function handleRemind(type, dis) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var bid, cid, _yield$axios, success, data, error, attrMaps;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!dis) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              bid = type ? 'b_movie_ppfx82b3_mv' : 'b_movie_q7kprp9c_mv';
              cid = type ? 'b_movie_ppfx82b3_mc' : 'b_movie_q7kprp9c_mc';
              window.lxTagReport(cid, bid, {
                performance_id: _this2.performanceId,
                activityId: _this2.priorityActivityCardVO.activityId
              });
              window.seedAction({
                evt: 'click',
                bid: bid,
                cid: cid,
                custom: {
                  custom: {
                    performance_id: _this2.performanceId,
                    activityId: _this2.priorityActivityCardVO.activityId
                  }
                }
              });
              _context2.next = 8;
              return axios({
                url: "".concat(ajaxNewMwebPreUrl, "/priority/purchase/reserveReminder"),
                method: 'post',
                data: {
                  type: type,
                  projectId: _this2.performanceId
                },
                headers: {
                  'Content-type': 'application/json'
                }
              });
            case 8:
              _yield$axios = _context2.sent;
              success = _yield$axios.success;
              data = _yield$axios.data;
              error = _yield$axios.error;
              attrMaps = _yield$axios.attrMaps;
              if (success) {
                _this2.$emit('changePriorityActivityStatus', type);
                _this2.bindMobile = attrMaps.mobile;
                _this2.start = type ? _this2.onSaleTime : _this2.earlySaleTime;
                _this2.handleSetCalendar();
              } else {
                _this2.$toast(error.message || '接口异常');
              }
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    closeSucceeEvent: function closeSucceeEvent() {
      this.showPopSucess = false;
    },
    iphoneClose: function iphoneClose() {
      this.calendarSuccessVis = false;
    },
    andriodCancle: function andriodCancle() {
      var _this3 = this;
      this.calendarAndriodVis = false;
      setTimeout(function () {
        _this3.showPopSucess = true;
      }, 500);
    },
    andriodConfirm: function andriodConfirm() {
      var _this4 = this;
      this.calendarAndriodVis = false;
      setTimeout(function () {
        Store.set('setCalendar', true);
        notifyCalendar({
          title: _this4.title,
          start: _this4.start
        });
      }, 500);
    },
    handleSetCalendar: function handleSetCalendar() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(Drip.UA.isNative && (Drip.UA.IS_MEITUAN || Drip.UA.IS_MAOYAN || Drip.UA.IS_DIANPING) && _this5.start)) {
                _context3.next = 9;
                break;
              }
              if (UA.osName === 'android') {
                // 安卓确认弹窗
                _this5.calendarAndriodVis = true;
              }
              if (!(UA.osName === 'ios')) {
                _context3.next = 7;
                break;
              }
              _context3.next = 5;
              return notifyCalendar({
                title: _this5.title,
                start: _this5.start
              });
            case 5:
              result = _context3.sent;
              if (result) {
                // 新日历弹窗 => todo
                _this5.calendarSuccessVis = true;
              } else {
                _this5.showPopSucess = true;
              }
            case 7:
              _context3.next = 10;
              break;
            case 9:
              _this5.showPopSucess = true;
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};